import DataMap from 'assets/components/dataMap/DataMap';
import ErrorWrapper from 'assets/components/inputs/wrappers/ErrorWrapper';
import ThemeTableSimple from 'assets/components/table/themes/Theme.Table.Simple';
import { getLocales } from 'assets/locales/Locale';
import { useSalesContractProvider } from '../../Sales.Contract.Hooks';
import Button from 'assets/components/button/Button';
import Icon from 'assets/components/icon/Icon';
import LinkButton from 'assets/components/button/LinkButton';
import ThemeButtonCircle from 'assets/components/button/themes/Theme.Button.Circle';
import Modal from 'assets/components/page/templates/Modal';
import { useState } from 'react';
import ContractClientHistory from 'models/sales/contractClientHistory/Model.ContractClientHistory';
import TextBox, { textBoxStyles } from 'assets/components/textBox/TextBox';
import { paragraphStyles } from 'module/claims/views/claimEdit/sections/claimEditInfo/ClaimEdit.Info';
import ThemeModalDefault from 'assets/components/page/templates/themes/Theme.Modal.Default';
import Theme from 'assets/themes/Theme.Common';

export default function ContractInfoClientHistory() {
  const { lang } = getLocales();
  const { selected } = useSalesContractProvider();
  const clientHistory = selected.clientHistory;
  const [details, setDetails] = useState<ContractClientHistory | null>(null);
  return (
    <>
      {!clientHistory?.length ? (
        <ErrorWrapper children={lang.noInfo} />
      ) : (
        <table className={ThemeTableSimple}>
          <thead>
            <tr>
              <th>{lang.name}</th>
              <th>{lang.startDate}</th>
              <th>{lang.endDate}</th>
              <th data-actions>{lang.actions}</th>
            </tr>
          </thead>
          <tbody>
            <DataMap
              data={clientHistory}
              render={({ data }) => (
                <tr key={data.id}>
                  <td>{data.client.name}</td>
                  <td>{data.startDateUtc}</td>
                  <td>{data.endDateUtc}</td>
                  <td>
                    <div style={{ display: 'flex' }}>
                      <LinkButton
                        class={ThemeButtonCircle}
                        url={data.documentAggregate?.url}
                        media={<Icon class="fas-download" />}
                        target="_blank"
                        disabled={!data.documentAggregate?.url}
                        htmlElementProps={{
                          title: !data.documentAggregate?.url ? lang.missingContractDocument : lang.download,
                        }}
                      />
                      <Button
                        class={ThemeButtonCircle}
                        media={<Icon class="fas-info" />}
                        onClick={setDetails}
                        data={data}
                        htmlElementProps={{ title: lang.info }}
                      />
                    </div>
                  </td>
                </tr>
              )}
            />
          </tbody>
        </table>
      )}
      {details && (
        <Modal
          subcomponents={ThemeModalDefault}
          onClose={() => setDetails(null)}
          header={lang.clientInfo}
          render={
            <>
              <div style={{ ...paragraphStyles, padding: Theme.Size.L }}>
                <h2 style={{ gridColumn: '1/-1' }}>{lang.generalInformation}</h2>
                <TextBox
                  class={textBoxStyles.block.flexBlock}
                  title={`${lang.startDate}: `}
                  subtitle={details.startDateUtc ?? 'N/A'}
                />
                <TextBox
                  class={textBoxStyles.block.flexBlock}
                  title={`${lang.endDate}: `}
                  subtitle={details.endDateUtc ?? 'N/A'}
                />
                <TextBox
                  class={textBoxStyles.block.flexBlock}
                  title={`${lang.firstName}: `}
                  subtitle={details.client?.firstName ?? 'N/A'}
                />
                <TextBox
                  class={textBoxStyles.block.flexBlock}
                  title={`${lang.lastName}: `}
                  subtitle={details.client?.lastName ?? 'N/A'}
                />
                <TextBox
                  class={textBoxStyles.block.flexBlock}
                  title={`${lang.language}: `}
                  subtitle={details.client?.primaryLangugaeIsoCode ?? 'N/A'}
                />
                <TextBox
                  class={textBoxStyles.block.flexBlock}
                  title={`${lang.taxExempt}: `}
                  subtitle={details.client?.taxExempt ? <Icon class="fas-check" /> : <Icon class="fas-times" />}
                />
                <TextBox
                  class={textBoxStyles.block.flexBlock}
                  title={`${lang.legacy}: `}
                  subtitle={details.client?.isLegacy ? <Icon class="fas-check" /> : <Icon class="fas-times" />}
                />
                <h2 style={{ gridColumn: '1/-1' }}>{lang.contactInfo}</h2>
                <TextBox
                  class={textBoxStyles.block.flexBlock}
                  title={`${lang.email}: `}
                  subtitle={
                    details.client?.email ? (
                      <a href={`mailto:${details.client.email}`} style={{ color: '#24408a' }}>
                        {details.client.email}
                      </a>
                    ) : (
                      'N/A'
                    )
                  }
                />
                <TextBox
                  class={textBoxStyles.block.flexBlock}
                  title={`${lang.phoneNumber}: `}
                  subtitle={
                    details.client?.phone ? (
                      <a href={`tel:${details.client.phone}`} style={{ color: '#24408a' }}>
                        {details.client.phone}
                      </a>
                    ) : (
                      'N/A'
                    )
                  }
                />
                <h2 style={{ gridColumn: '1/-1' }}>{lang.address}</h2>
                <TextBox
                  class={textBoxStyles.block.flexBlock}
                  title={`${lang.streetAddress}: `}
                  subtitle={details.client?.streetAddress ?? 'N/A'}
                />
                <TextBox
                  class={textBoxStyles.block.flexBlock}
                  title={`${lang.postalCode}: `}
                  subtitle={details.client?.postalCode ?? 'N/A'}
                />
                <TextBox
                  class={textBoxStyles.block.flexBlock}
                  title={`${lang.muncipality}: `}
                  subtitle={details.client?.muncipality ?? 'N/A'}
                />
                <TextBox
                  class={textBoxStyles.block.flexBlock}
                  title={`${lang.provinceCode}: `}
                  subtitle={details.client?.countryCode ?? 'N/A'}
                />
                <TextBox
                  class={textBoxStyles.block.flexBlock}
                  title={`${lang.provinceCode}: `}
                  subtitle={details.client?.countryCode ?? 'N/A'}
                />
                <TextBox
                  class={textBoxStyles.block.flexBlock}
                  title={`${lang.city}: `}
                  subtitle={details.client?.city ?? 'N/A'}
                />
              </div>
              <table className={ThemeTableSimple}>
                <thead>
                  <tr>
                    <th>{lang.type}</th>
                    <th>{lang.name}</th>
                    <th data-actions>{lang.actions}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{lang.aggregate}</td>
                    <td>{details.documentAggregate?.name}</td>
                    <td>
                      <LinkButton
                        class={ThemeButtonCircle}
                        url={details.documentAggregate?.url}
                        media={<Icon class="fas-download" />}
                        target="_blank"
                        disabled={!details.documentAggregate?.url}
                        htmlElementProps={{
                          title: !details.documentAggregate?.url ? lang.missingContractDocument : lang.download,
                        }}
                      />
                    </td>
                  </tr>
                  <DataMap
                    data={selected.transferDocuments ?? []}
                    render={({ data: transferDoc }) => (
                      <tr key={transferDoc.id}>
                        <td>{lang.transferDocument}</td>
                        <td>{transferDoc?.name}</td>
                        <td>
                          <LinkButton
                            class={ThemeButtonCircle}
                            url={transferDoc?.url}
                            media={<Icon class="fas-download" />}
                            target="_blank"
                            disabled={!transferDoc?.url}
                            htmlElementProps={{ title: lang.download }}
                          />
                        </td>
                      </tr>
                    )}
                  />
                </tbody>
              </table>
            </>
          }
        />
      )}
    </>
  );
}
